<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding: 0px 4px;">
                <div class="info_cont" style="padding-top: 10px;" v-show="IsEnabled==1">
                        <div class="mctitle"><i class="far fa-calendar-alt" style="margin-right:10px;"></i>Időpont foglalás - személyes adatok</div>

                        <div class="resp_table">
                            <div class="tablerow">
                                <div class="col2">
                                    <GrcText ref="txtNev" grc_labeltext="Név:" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtAnyjaNeve');"
                                    style="margin-bottom:20px;"
                                    />
                                </div>
                                <div class="col2">                            
                                    <GrcText ref="txtAnyjaNeve" grc_labeltext="Anyja neve:" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px" 
                                    v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiHely');"
                                    style="margin-bottom:20px;"
                                    />
                                </div>
                            </div>

                            <div class="tablerow">
                                <div class="col2">
                                    <GrcText ref="txtSzuletesiHely" grc_labeltext="Születési hely:" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px" 
                                    v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiIdo');"
                                    style="margin-bottom:20px;"
                                    />
                                </div>
                                <div class="col2">                        
                                    <GrcDate ref="txtSzuletesiIdo" v-model="SzuletesiIdo" grc_dateformat="ymd" grc_sep="." 
                                    grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtCim');"
                                    v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo')"
                                    v-on:dropdownclosed="SetPopupRef('')"
                                    style="margin-bottom:20px;"
                                    />
                                </div>
                            </div>

                        </div>

                        <div class="resp_table">
                            <div class="tablerow">
                                <div class="col1">
                                    <GrcText ref="txtCim" grc_labeltext="Levelezési cím:" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px" grc_readonly="true"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtTaj');"
                                    style="margin-bottom:4px;"
                                    v-show="ShowCimReszletes==false"
                                    />

                                    <div style="width:100%; box-sizing:border-box; text-align:left; margin-bottom:20px;" v-show="ShowCimReszletes==false">
                                        <span class="btnShowCimReszletes" style="margin-right:15px;" @click="btnShowCimReszletes_click">Cím módosítása<i class="fas fa-angle-double-right" style="margin-left:10px;"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="div_cim_reszletes" v-show="ShowCimReszletes">

                            <div class="lbl_cim">Levelezési cím:</div>

                            <div class="resp_table_2">
                                <div class="tablerow_2">
                                    <div class="col2_2">
                                        <GrcIrszam ref="txtIrszam"
                                        grc_labeltext="Irányítószám:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        v-on:valuechanged="Irszam_ValueChanged()"
                                        v-on:grc-keydown-enter="SetControlToFocus('cboHelyseg');"
                                        style="margin-bottom:20px;"
                                        />
                                    </div>
                                    <div class="col2_2">                                
                                        <GrcCombo ref="cboHelyseg" v-model="cboHelyseg" grc_labeltext="Helység:"
                                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                                        grc_keyfield="id" grc_displayfield="Megnevezes"
                                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtKozterNev');"
                                        v-on:valuechanged="cboHelyseg_valuechanged"
                                        v-on:dropdownopened="SetPopupRef('cboHelyseg')"
                                        v-on:dropdownclosed="SetPopupRef('')"
                                        style="margin-bottom:20px;"
                                        grc_textclass="frmMedicall_UserData_ComboStyle"
                                        />
                                    </div>
                                </div>

                                <div class="tablerow_2">
                                    <div class="col2_2">
                                        <GrcText ref="txtKozterNev"
                                        grc_labeltext="Közterület:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        v-on:grc-keydown-enter="SetControlToFocus('cboKozterJelleg');"
                                        style="margin-bottom:20px;"
                                        />
                                    </div>
                                    <div class="col2_2">
                                        <GrcCombo ref="cboKozterJelleg" v-model="cboKozterJelleg" grc_labeltext="Közterület jelleg:"
                                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                                        grc_keyfield="id" grc_displayfield="Megnevezes"
                                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtHazszam');"
                                        v-on:dropdownopened="SetPopupRef('cboKozterJelleg')"
                                        v-on:dropdownclosed="SetPopupRef('')"
                                        style="margin-bottom:20px;"
                                        grc_textclass="frmMedicall_UserData_ComboStyle"
                                        />
                                    </div>
                                </div>

                                <div class="tablerow_2">
                                    <div class="col2_2">
                                        <GrcText ref="txtHazszam"
                                        grc_labeltext="Házszám:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        v-on:grc-keydown-enter="SetControlToFocus('txtEpulet');"
                                        style="margin-bottom:20px;"
                                        />
                                    </div>
                                    <div class="col2_2">
                                        <GrcText ref="txtEpulet"
                                        grc_labeltext="Épület:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        v-on:grc-keydown-enter="SetControlToFocus('txtLepcsohaz');"
                                        style="margin-bottom:20px;"
                                        />
                                    </div>
                                </div>

                                <div class="tablerow_2">
                                    <div class="col2_2">
                                        <GrcText ref="txtLepcsohaz"
                                        grc_labeltext="Lépcsőház:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        v-on:grc-keydown-enter="SetControlToFocus('txtEmelet');"
                                        style="margin-bottom:20px;"
                                        />
                                    </div>
                                    <div class="col2_2">
                                        <GrcText ref="txtEmelet"
                                        grc_labeltext="Emelet:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        v-on:grc-keydown-enter="SetControlToFocus('txtAjto');"
                                        style="margin-bottom:20px;"
                                        />
                                    </div>
                                </div>

                                <div class="tablerow_2">
                                    <div class="col2_2">
                                        <GrcText ref="txtAjto"
                                        grc_labeltext="Ajtó:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        v-on:grc-keydown-enter="SetControlToFocus('txtTaj');"
                                        style="margin-bottom:20px;"
                                        />
                                    </div>
                                </div>
                            </div>
                        
                        </div>


                        <div class="resp_table_3">
                            <div class="tablerow_3">
                                <div class="col2_3" style="vertical-align: middle;">
                                    <table style="width:100%; margin-bottom:10px;" cellspacing="0" cellpadding="0">
                                        <tr>
                                        <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkTaj" v-on:valuechanged="chkTaj_changed" /></td>
                                        <td valign="top" style="text-align:justify; font-family:'PremiumDefault'; font-size:14px; line-height:18px; color:#222; padding-top: 2px;" v-html="TajCheckText">
                                        </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col2_3">
                                    <GrcTajszam ref="txtTaj" grc_labeltext="TAJ szám:" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px" 
                                    v-on:grc-keydown-enter="SetControlToFocus('txtTelefonszam');"
                                    style="margin-bottom:20px;"
                                    v-show="VanTaj==1"
                                    />

                                    <GrcText ref="txtOkmanyszam" grc_labeltext="Személyazonosító okmány száma:" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px" 
                                    v-on:grc-keydown-enter="SetControlToFocus('txtTelefonszam');"
                                    style="margin-bottom:20px;"
                                    v-show="VanTaj==0"
                                    />
                                </div>
                            </div>

                            <div class="tablerow_3">
                                <div class="col2_3">
                                    <GrcText ref="txtTelefonszam" grc_labeltext="Értesítési telefonszám (06-al kezdve):" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px" 
                                    v-on:grc-keydown-enter="SetControlToFocus('txtEmailCim');"
                                    style="margin-bottom:20px;"
                                    />
                                </div>
                                <div class="col2_3">
                                    <GrcText ref="txtEmailCim" grc_labeltext="Értesítési e-mail cím:" grc_placeholder="..."
                                    grc_labelmode="" grc_labelwidth="200px" 
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="margin-bottom:20px;"
                                    />
                                </div>
                            </div>
                        </div>

                        <table style="width:100%; margin-bottom:10px;" cellspacing="0" cellpadding="0">
                            <tr>
                            <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkNyilatkozat" /></td>
                            <td valign="top" style="text-align:justify; font-family:'PremiumDefault'; font-size:14px; line-height:18px; color:#323232; padding-top: 2px;"
                            v-html="NyilatkozatSzoveg">
                            </td>
                            </tr>
                        </table>



                        <div style="width:100%; box-sizing:border-box; text-align:center; margin-top: 20px;">
                            <span class="btnTovabb" style="margin-right:15px;" @click="btnTovabb_click">Tovább<i class="fas fa-angle-double-right" style="margin-left:10px;"></i></span>
                            <span class="btnMegsem" style="margin-left:15px;" @click="btnMegsem_click"><i class="fas fa-times" style="margin-right:10px;"></i>Mégsem</span>
                        </div>
                </div>
                <div class="info_cont" style="text-align: center;" v-show="IsEnabled==0">
                    <span>a hívás azonosító érvénytelen</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcTajszam from '../GrcComponents/GrcTajszam.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcIrszam from '../GrcComponents/GrcIrszam.vue'

export default {
  name: 'frmMedicall_UserData',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcText,
      GrcTajszam,
      GrcCheckboxMobile,
      GrcDate,
      GrcCombo,
      GrcIrszam,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmMedicall",
            IsEnabled:-1,
            PMS:"",
            LinkUrl:"",

            SzuletesiIdo:"",
            TajCheckText:"Van TAJ számom",
            VanTaj:1,
            NyilatkozatSzoveg:"",

            cboHelyseg:0,
            cboKozterJelleg:0,
            ShowCimReszletes:false,
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    btnShowCimReszletes_click()
    {
        this.ShowCimReszletes =  true;
    },

    async Irszam_ValueChanged()
    {
        var pIrszam = pIrszam = this.$refs.txtIrszam.GetText(); 

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sIrszam: pIrszam,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_UserData_GetHelysegek", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q.APPERR[0].ERR);
            //alert(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.cboHelyseg.SetDataSource(Q.RESULT);
        if (Q.RESULT.length>1)
        {
            this.$refs.cboHelyseg.SetValue(Q.RESULT[1].id);
        }
        else
        {
            this.$refs.cboHelyseg.SetValue(0);
        }
        this.SetControlToFocus("cboHelyseg");

        this.$refs.GRCDB.HideLoading();
    },

    cboHelyseg_valuechanged()
    {
        this.$refs.cboHelyseg.HideError();
    },




    chkTaj_changed()
    {
        if (this.$refs.chkTaj.GetValue() == 1)
        {
            this.VanTaj = 1;
            this.TajCheckText = "Van TAJ számom";
        }
        else
        {
            this.VanTaj = 0;
            this.TajCheckText = "Nincs TAJ számom";
        }
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        if (pNextComp == "txtCim")
        {
            if (this.ShowCimReszletes) { pNextComp = "txtIrszam"; }
        }

        if ((pNextComp == "txtTaj")&&(this.VanTaj==0))
        {
            pNextComp = "txtOkmanyszam";
        }

        this.$refs[pNextComp].SetFocus();
    },


    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmMedicall", pCompName);
    },


    SetLang()
    {
        this.NyilatkozatSzoveg = this.GetTextBookItem("UserDataNyilatkozat");
        this.Init();
    },

    HideErrors()
    {
        this.$refs.txtNev.HideError();
        this.$refs.txtAnyjaNeve.HideError();
        this.$refs.txtSzuletesiHely.HideError();
        this.$refs.txtSzuletesiIdo.HideError();
        this.$refs.txtIrszam.HideError();
        this.$refs.cboHelyseg.HideError();
        this.$refs.txtKozterNev.HideError();
        this.$refs.cboKozterJelleg.HideError();
        this.$refs.txtHazszam.HideError();
        this.$refs.txtTaj.HideError();
        this.$refs.txtOkmanyszam.HideError();
        this.$refs.txtTelefonszam.HideError();
        this.$refs.txtEmailCim.HideError();

    },

    ScrollToComponent(pCompName)
    {
        var t = grccomp_findPos(this.$refs[pCompName].$el).top;
        t = t - 60;
        grcmain_scrollTo(t);
    },

    btnMegsem_click()
    {
        this.$refs.txtNev.SetText("");
        this.$refs.txtAnyjaNeve.SetText("");
        this.$refs.txtSzuletesiHely.SetText("");
        this.$refs.txtSzuletesiIdo.SetText("");
        
        this.$refs.txtIrszam.SetText("");
        this.$refs.cboHelyseg.SetValue(0);
        this.$refs.txtKozterNev.SetText("");
        this.$refs.cboKozterJelleg.SetValue(0);
        this.$refs.txtHazszam.SetText("");
        this.$refs.txtEpulet.SetText("");
        this.$refs.txtLepcsohaz.SetText("");
        this.$refs.txtEmelet.SetText("");
        this.$refs.txtAjto.SetText("");

        this.$refs.txtTaj.SetText("");
        this.$refs.txtOkmanyszam.SetText("");
        this.$refs.txtTelefonszam.SetText("");
        this.$refs.txtEmailCim.SetText("");

        this.RedirToMedicall(0);
    },

    async btnTovabb_click()
    {
        this.HideErrors();

        var CheckOK = true;
        var FirstErrorComp = "";

        if (this.$refs.txtNev.GetText().trim().length < 5)
        {
            this.$refs.txtNev.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtNev"; }
        }

        if (this.$refs.txtAnyjaNeve.GetText().trim().length < 5)
        {
            this.$refs.txtAnyjaNeve.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtAnyjaNeve"; }
        }

        if (this.$refs.txtSzuletesiHely.GetText().trim().length < 3)
        {
            this.$refs.txtSzuletesiHely.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtSzuletesiHely"; }
        }

        if (this.$refs.txtSzuletesiIdo.IsValid(false) == false)
        {
            this.$refs.txtSzuletesiIdo.ShowError("A dátum nincs megadva vagy helytelen!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtSzuletesiIdo"; }
        }

        if (this.$refs.txtIrszam.GetText().trim().length < 4)
        {
            this.$refs.txtIrszam.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtIrszam"; }
        }

        if (this.$refs.cboHelyseg.GetValue() == 0)
        {
            this.$refs.cboHelyseg.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "cboHelyseg"; }
        }

        if (this.$refs.txtKozterNev.GetText().trim().length < 3)
        {
            this.$refs.txtKozterNev.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtKozterNev"; }
        }

        if (this.$refs.cboKozterJelleg.GetValue() == 0)
        {
            this.$refs.cboKozterJelleg.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "cboKozterJelleg"; }
        }

        if (this.$refs.txtHazszam.GetText().trim().length < 1)
        {
            this.$refs.txtHazszam.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtHazszam"; }
        }


        if (this.VanTaj == 1)
        {
            if (this.$refs.txtTaj.GetText().trim().length != 9)
            {
                this.$refs.txtTaj.ShowError("A TAJ szám nincs megadva vagy helytelen!");
                CheckOK = false;
                if (FirstErrorComp == "") { FirstErrorComp = "txtTaj"; }
            }
        }
        else
        {
            if (this.$refs.txtOkmanyszam.GetText().trim().length < 5)
            {
                this.$refs.txtOkmanyszam.ShowError("Az okmányszám nincs megadva vagy helytelen!");
                CheckOK = false;
                if (FirstErrorComp == "") { FirstErrorComp = "txtOkmanyszam"; }
            }
        }

        if (this.$refs.txtTelefonszam.GetText().trim().length < 10)
        {
            this.$refs.txtTelefonszam.ShowError("A telefonszám nincs megadva vagy helytelen! Helyes formátum: 06201234567");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtTelefonszam"; }
        }

        if (this.$refs.txtTelefonszam.GetText().startsWith("06") == false)
        {
            this.$refs.txtTelefonszam.ShowError("A telefonszám helytelen! Helyes formátum: 06201234567");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtTelefonszam"; }
        }

        if (this.$refs.txtEmailCim.GetText().trim().length == 0)
        {
            this.$refs.txtEmailCim.ShowError("A mező kitöltése kötelező!");
            CheckOK = false;
            if (FirstErrorComp == "") { FirstErrorComp = "txtEmailCim"; }
        }
        else
        {
            if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
            {
                this.$refs.txtEmailCim.ShowError("Az e-mail cím helytelen!");
                CheckOK = false;
                if (FirstErrorComp == "") { FirstErrorComp = "txtEmailCim"; }
            }
        }

        if (CheckOK == false)
        {
            this.ScrollToComponent(FirstErrorComp);
            return;
        }


        if (this.$refs.chkNyilatkozat.GetValue() == 0)
        {
            this.ShowInfoDialog("A hozzájáruló nyilatkozat elfogadása kötelező!", "200");            
            return;
        }

        await this.RegUserData();
        this.RedirToMedicall(1);
    },

    async RegUserData()
    {
        this.$refs.GRCDB.ShowLoading(false);

        var tmpTaj = this.$refs.txtTaj.GetText();
        var tmpOkmanyszam = this.$refs.txtOkmanyszam.GetText();

        if (this.VanTaj == 1) { tmpOkmanyszam = ""; }
        else { tmpTaj = ""; }
        
        var QP = {
            sPMS: this.PMS,
            sNev: this.$refs.txtNev.GetText(),
            sAnyjaNeve: this.$refs.txtAnyjaNeve.GetText(),
            sSzuletesiHely: this.$refs.txtSzuletesiHely.GetText(),
            sSzuletesiIdo: this.$refs.txtSzuletesiIdo.GetText(),
            sIrszam: this.$refs.txtIrszam.GetText(),
            iHelysegID: this.$refs.cboHelyseg.GetValue(),
            sKozterNev: this.$refs.txtKozterNev.GetText(),
            iKozterJellegID: this.$refs.cboKozterJelleg.GetValue(),
            sHazszam: this.$refs.txtHazszam.GetText(),
            sEpulet: this.$refs.txtEpulet.GetText(),
            sLepcsohaz: this.$refs.txtLepcsohaz.GetText(),
            sEmelet: this.$refs.txtEmelet.GetText(),
            sAjto: this.$refs.txtAjto.GetText(),
            sTaj: tmpTaj,
            sOkmanyszam: tmpOkmanyszam,
            sTelefon: this.$refs.txtTelefonszam.GetText(),
            sEmailCim: this.$refs.txtEmailCim.GetText(),
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_UserData_RegData", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.$refs.GRCDB.HideLoading();

    },


    async RedirToMedicall(pOK)
    {
        var tmpTaj = this.$refs.txtTaj.GetText();
        var tmpOkmanyszam = this.$refs.txtOkmanyszam.GetText();

        var VNEV = "";
        var KNEV = "";
        var NA = this.$refs.txtNev.GetText().trim().split(" ");
        if (NA.length>0) { VNEV = NA[0]; }
        for(var i=1; i<NA.length; i++)
        {
            KNEV = KNEV + NA[i] + " ";
        }

        KNEV = KNEV.trim();


        if (this.VanTaj == 1) { tmpOkmanyszam = ""; }
        else { tmpTaj = ""; }

        this.scrollToTop();

        if (this.LinkUrl == "") { return; }

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = this.LinkUrl;
        var myInput;

        myInput = document.createElement("input");
        myInput.setAttribute("name", "IsOK");
        myInput.setAttribute("id", "IsOK");
        myInput.setAttribute("value", pOK);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Vezeteknev");
        myInput.setAttribute("id", "Vezeteknev");
        myInput.setAttribute("value", VNEV);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Keresztnev");
        myInput.setAttribute("id", "Keresztnev");
        myInput.setAttribute("value", KNEV);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "AnyjaNeve");
        myInput.setAttribute("id", "AnyjaNeve");
        myInput.setAttribute("value", this.$refs.txtAnyjaNeve.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "SzuletesiHely");
        myInput.setAttribute("id", "SzuletesiHely");
        myInput.setAttribute("value", this.$refs.txtSzuletesiHely.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "SzuletesiIdo");
        myInput.setAttribute("id", "SzuletesiIdo");
        myInput.setAttribute("value", this.$refs.txtSzuletesiIdo.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Irszam");
        myInput.setAttribute("id", "Irszam");
        myInput.setAttribute("value", this.$refs.txtIrszam.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Varos");
        myInput.setAttribute("id", "Varos");
        myInput.setAttribute("value", this.$refs.cboHelyseg.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "KozterNev");
        myInput.setAttribute("id", "KozterNev");
        myInput.setAttribute("value", this.$refs.txtKozterNev.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "KozterTipus");
        myInput.setAttribute("id", "KozterTipus");
        myInput.setAttribute("value", this.$refs.cboKozterJelleg.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Hazszam");
        myInput.setAttribute("id", "Hazszam");
        myInput.setAttribute("value", this.$refs.txtHazszam.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Epulet");
        myInput.setAttribute("id", "Epulet");
        myInput.setAttribute("value", this.$refs.txtEpulet.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Lepcsohaz");
        myInput.setAttribute("id", "Lepcsohaz");
        myInput.setAttribute("value", this.$refs.txtLepcsohaz.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Emelet");
        myInput.setAttribute("id", "Emelet");
        myInput.setAttribute("value", this.$refs.txtEmelet.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Ajto");
        myInput.setAttribute("id", "Ajto");
        myInput.setAttribute("value", this.$refs.txtAjto.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "VanTaj");
        myInput.setAttribute("id", "VanTaj");
        myInput.setAttribute("value", this.VanTaj);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "TajSzam");
        myInput.setAttribute("id", "TajSzam");
        myInput.setAttribute("value", tmpTaj);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Okmanyszam");
        myInput.setAttribute("id", "Okmanyszam");
        myInput.setAttribute("value", tmpOkmanyszam);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "Telefonszam");
        myInput.setAttribute("id", "Telefonszam");
        myInput.setAttribute("value", this.$refs.txtTelefonszam.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "EmailCim");
        myInput.setAttribute("id", "EmailCim");
        myInput.setAttribute("value", this.$refs.txtEmailCim.GetText());
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PMS");
        myInput.setAttribute("id", "PMS");
        myInput.setAttribute("value", this.PMS);
        myForm.appendChild(myInput);

        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        

    },


    async Init()
    {
        this.PMS = "";
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "mcuserdata") && (GRCAPP_GetParameters.PMS != "") && (GRCAPP_GetParameters.PMS != undefined))
        {
            this.PMS = GRCAPP_GetParameters.PMS;
            GRCAPP_GetParameters.PMS = "";
        }

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sPMS: this.PMS,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_UserData_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.IsEnabled = 0;

            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        if (Q.RESULT[0].LinkUrl == "")
        {
            this.$refs.GRCDB.HideLoading();
            this.IsEnabled = 0;
            return;
        }

        if ((Q.RESULT[0].Irszam == "") || (Q.RESULT[0].HelysegID == 0) || (Q.RESULT[0].KozterNev == "") || (Q.RESULT[0].KozterJellegID == 0) || (Q.RESULT[0].Hazszam == ""))
        { this.ShowCimReszletes = true; }

        this.$refs.cboHelyseg.SetDataSource(Q.HELYSEGEK);
        this.$refs.cboKozterJelleg.SetDataSource(Q.KOZTER);


        this.LinkUrl = Q.RESULT[0].LinkUrl;
        this.$refs.txtNev.SetText(Q.RESULT[0].Nev);
        this.$refs.txtAnyjaNeve.SetText(Q.RESULT[0].AnyjaNeve);
        this.$refs.txtSzuletesiHely.SetText(Q.RESULT[0].SzuletesiHely);
        this.$refs.txtSzuletesiIdo.SetText(Q.RESULT[0].SzuletesiIdo);
        this.$refs.txtCim.SetText(Q.RESULT[0].Cim);
        this.$refs.txtTaj.SetText(Q.RESULT[0].Taj);
        this.$refs.txtOkmanyszam.SetText(Q.RESULT[0].OkmanySzam);
        this.$refs.txtTelefonszam.SetText(Q.RESULT[0].Telefon);
        this.$refs.txtEmailCim.SetText(Q.RESULT[0].EmailCim);

        this.$refs.txtNev.SetReadonly(Q.RESULT[0].Nev != "");
        this.$refs.txtAnyjaNeve.SetReadonly(Q.RESULT[0].AnyjaNeve != "");
        this.$refs.txtSzuletesiHely.SetReadonly(Q.RESULT[0].SzuletesiHely != "");
        this.$refs.txtSzuletesiIdo.SetReadonly(Q.RESULT[0].SzuletesiIdo != "");

        this.$refs.txtIrszam.SetText(Q.RESULT[0].Irszam);
        this.$refs.cboHelyseg.SetValue(Q.RESULT[0].HelysegID);
        this.$refs.txtKozterNev.SetText(Q.RESULT[0].KozterNev);
        this.$refs.cboKozterJelleg.SetValue(Q.RESULT[0].KozterJellegID);
        this.$refs.txtHazszam.SetText(Q.RESULT[0].Hazszam);
        this.$refs.txtEpulet.SetText(Q.RESULT[0].Epulet);
        this.$refs.txtLepcsohaz.SetText(Q.RESULT[0].Lepcsohaz);
        this.$refs.txtEmelet.SetText(Q.RESULT[0].Emelet);
        this.$refs.txtAjto.SetText(Q.RESULT[0].Ajto);


        this.$refs.chkTaj.SetValue(1);
        /*
        if (Q.RESULT[0].Taj != "")
        {
            this.$refs.chkTaj.SetValue(1);
        }
        else
        {
            this.$refs.chkTaj.SetValue(0);
        }
        */

        this.chkTaj_changed();

        
        this.$refs.GRCDB.HideLoading();

        this.IsEnabled = 1;

    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1; 
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.info_cont
{
    width: 100%;
    max-width: 800px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-family: "PremiumDefault";
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding: 30px 8px;
    color: #323232;
    margin: 10px auto;
    border: solid 1px #ccc;
    border-radius: 3px;
    -webkit-box-shadow: rgb(221 221 221) 2px 2px 4px;
    box-shadow: rgb(221 221 221) 2px 2px 4px;
    background-color: #f0f0f0;    
}

.mctitle
{
    width: 100%;
    box-sizing: border-box;
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 24px;
    font-weight:500;
    text-align: center;
    color: var(--premblue);
    margin:10px 0px 20px 0px;
}


.btnTovabb
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  border:solid 1px var(--premblue);
}

.btnTovabb:hover
{
  background-color: var(--premgreen);
  color:#fff;
  border:solid 1px var(--premgreen);
}

.btnMegsem
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:#e0e0e0;
  color:#888;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  border:solid 1px #ccc;
}

.btnMegsem:hover
{
  background-color: var(--premgreen);
  color:#fff;
  border:solid 1px var(--premgreen);
}

.div_cim_reszletes
{
    width:100%;
    box-sizing: border-box;
}

.btnShowCimReszletes
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:4px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  border:solid 1px var(--premblue);
}

.btnShowCimReszletes:hover
{
  background-color: var(--premgreen);
  color:#fff;
  border:solid 1px var(--premgreen);
}

.lbl_cim
{
    width:100%;
    box-sizing: border-box;
  font-size: 16px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: 500;
  text-align: left;  
  color:var(--premblue);
  padding:0px;
  margin-bottom: 10px;
}

>>> .frmMedicall_UserData_ComboStyle
{
    background-color: #fff;
}


.resp_table
{
    width: 100%;
    box-sizing: border-box;
    display: table;    
}

.tablerow
{
    display: table-row;    
}

.col1
{
    width: 100%;
    box-sizing: border-box;
    padding: 2px;
    display: table-cell;    
}

.col2
{
    width: 50%;
    box-sizing: border-box;
    padding: 2px;
    display: table-cell;    
}

.resp_table_2
{
    width: 100%;
    box-sizing: border-box;
    display: table;    
}

.tablerow_2
{
    display: table-row;    
}

.col2_2
{
    width: 50%;
    box-sizing: border-box;
    padding: 2px;
    display: table-cell;    
}



.resp_table_3
{
    width: 100%;
    box-sizing: border-box;
    display: table;    
}

.tablerow_3
{
    display: table-row;    
}

.col2_3
{
    width: 50%;
    box-sizing: border-box;
    padding: 2px;
    display: table-cell;    
}

@media (max-width:599px)
{

    .tablerow_3
    {
        display: block;
        box-sizing: border-box;
    }

    .col2_3
    {
        width: 100%;
        box-sizing: border-box;
        padding: 2px;
        display: block;   
    }


}


@media (max-width:400px)
{

    .tablerow
    {
        display: block;
        box-sizing: border-box;
    }

    .col1
    {
        width: 100%;
        box-sizing: border-box;
        padding: 2px;
        display: block;   
    }

    .col2
    {
        width: 100%;
        box-sizing: border-box;
        padding: 2px;
        display: block;   
    }

    .tablerow_3
    {
        display: block;
        box-sizing: border-box;
    }

    .col2_3
    {
        width: 100%;
        box-sizing: border-box;
        padding: 2px;
        display: block;   
    }


}




</style>